import { Amplify } from 'aws-amplify';
import outputs from './amplify_outputs.json';

const PLACEHOLDER = '__REPLACE_AFTER_AMPX_SANDBOX__';

const auth = outputs.auth;
const poolReady =
  auth &&
  auth.user_pool_id &&
  auth.user_pool_id !== PLACEHOLDER &&
  auth.user_pool_client_id &&
  auth.user_pool_client_id !== PLACEHOLDER;

if (poolReady) {
  Amplify.configure(outputs);
}

/**
 * Base URL de l'API HTTP (sans slash final).
 * Priorité : REACT_APP_BACKEND_URL (override local / preview), puis amplify_outputs.json -> custom.restApiUrl.
 * En production, l'URL doit venir du déploiement Amplify (amplify_outputs.json).
 */
export function getRestApiBaseUrl() {
  const fromEnv = (process.env.REACT_APP_BACKEND_URL || '').trim().replace(/\/$/, '');
  if (fromEnv) return fromEnv;
  const url = typeof outputs.custom?.restApiUrl === 'string' ? outputs.custom.restApiUrl.trim() : '';
  return url.replace(/\/$/, '');
}

export function isAmplifyAuthConfigured() {
  return Boolean(poolReady);
}
